import {html} from 'lit';
import '../../grid/grid-row.js';
import '../../grid/grid-col.js';
import Base from '../../base.js';
import styles from './label.css' assert {type: 'css'};

/**
 * @element inv-form-label
 *
 * @class FormLabel
 * @classdesc This is a web component that creates a form label.
 *
 * @property {string} name - The name of the label.
 *
 * @cssproperty --inv-form-label-color
 * @description The font color for the host element.
 * @type {string}
 * @default #6d809c
 *
 * @cssproperty --inv-font-family
 * @description The font family for the host element.
 * @type {string}
 * @default 'Inter'
 *
 * @cssproperty --inv-form-label-font-weight
 * @description The font weight for the host element.
 * @type {number}
 * @default 500
 *
 * @cssproperty --inv-form-label-font-size
 * @description The font size for the host element.
 * @type {string}
 * @default 0.8em
 *
 * @cssproperty --inv-form-label-margin-top
 * @description The top margin for the label element.
 * @type {string}
 * @default 0
 *
 * @cssproperty --inv-form-label-margin-bottom
 * @description The bottom margin for the label element.
 * @type {string}
 * @default 0
 */

export default class FormLabel extends Base {
    static get properties() {
        return {
            name: {
                type: String,
            },
        };
    }

    constructor() {
        super();
        this.name = 'label';
        this.type = 'label';
    }

    getStyleSheets() {
        return [...super.getStyleSheets(), styles];
    }

    render() {
        return html`
            <label for="${this.name}">
                <slot></slot>
            </label>
        `;
    }
}

FormLabel.register();
